import { useNavigate } from "react-router-dom";
import Loading from "./../../../Loading/Loading";
const AsmaLBRow = ({ student, batch }) => {
  const navigate = useNavigate();
  const loadDetails = (e) => {
    navigate(`${student?.sn}`, {
      state: { id: 1, batch: batch, student: student },
    });
    // <Link to="hi"/>
  };

  if (!student) {
    return <Loading></Loading>;
  }

  return (
    <tr onClick={loadDetails} className="hover">
      <th>{student?.sn}</th>
      <td>{student?.name?.toUpperCase()}</td>
      <td>{student?.completion} %</td>
      <td>{student?.gems}</td>
      {student?.asmaulhusna1data?.slice(0, 3).map((exam, idx) => (
        <td key={idx}>{exam?.Score ?? 0}</td>
      ))}

      <td>
        {student?.asmaulhusna1data?.slice(0, 3).reduce((total, exam) => {
          return total + (exam?.Score || 0);
        }, 0)}
      </td>
    </tr>
  );
};

export default AsmaLBRow;
